import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconComputerUse: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="computer-use, cursor"><path fillRule="evenodd" clipRule="evenodd" d="M20.25 3C20.6642 3 21 3.33579 21 3.75V20.25C21 20.6642 20.6642 21 20.25 21H3.75C3.33579 21 3 20.6642 3 20.25V3.75C3 3.33579 3.33579 3 3.75 3H20.25ZM8.52734 7.5791C7.94127 7.38403 7.38403 7.94127 7.5791 8.52734L10.2402 16.5127C10.475 17.2165 11.4805 17.1885 11.6758 16.4727L12.666 12.8418C12.6893 12.7564 12.7564 12.6893 12.8418 12.666L16.4727 11.6758C17.1885 11.4805 17.2165 10.475 16.5127 10.2402L8.52734 7.5791Z" fill="currentColor"/></CentralIconBase>;
};

export default IconComputerUse;
